import React from "react";
import { useQuery } from "../../hooks/";
import { StyledPaymentScreen } from "./styles";
import { Button } from "../../components";
import assets from "../../assets";

const SuccessPaymentScreen = () => {
  const query = useQuery();
  const uid = query.get("uid");
  const email = query.get("email");
  //const sessionId = query.get("session_id");

  return (
    <StyledPaymentScreen>
      <img src={assets.happyWoman} alt="" />
      <h1>Payment Successful!</h1>
      <p>
        Your reservation with ID <strong>{uid}</strong> was successfuly made.
        <br /> A confirmation email has been sent to: <strong>{email}</strong>
      </p>

      <p>
        Thank you for choosing Us! <br />
        If you have any questions, feel free to <span>contact us</span>.
      </p>

      <Button
        onClick={() => (window.location.href = "/home")}
        style={{ width: "300px", background: "#000" }}
      >
        Keep Exploring!
      </Button>
    </StyledPaymentScreen>
  );
};

export default SuccessPaymentScreen;
